<template>
  <div class="page-wrapper">
    <div class="item-wrapper">
      <div class="item-wrapper-top">
        <!-- PRD25030037 PRD25030032-4 JHH系统 JHH单 增加流程开关控制 是否自动派M4 -->
        <div class="item-wrapper-top-title">
          是否自动派M4
        </div>

        <el-switch @change="handleAutomaticDispatchM4Change" active-text="开启" inactive-text="关闭"
          v-model="automaticDispatchM4" />
      </div>

      <div class="item-wrapper-bottom">
        <el-alert type="warning" :show-icon="true" :closable="false">
          <template #title>
            <div style="margin-bottom: 8px;">
              【关闭】表示极吼吼小程序的订单产生后（此时工单状态为“待确认”），依旧进入现有的“待处理”页（由人工点击底部“转单M4”按钮，传入M4）
            </div>

            <div>
              【开启】表示极吼吼小程序的订单产生后（此时工单状态为“待确认”），由系统代替人工立即（全部默认点击了“转单M4”按钮的效果）传入M4。
            </div>
          </template>
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { hideLoading, showLoading } from "@/components/loading/loading";
import { getAutomaticDispatchM4, updateAutomaticDispatchM4 } from "@/api/dispatchConfiguration";

/**
 * 派单配置
 */
export default {
  name: "DispatchConfiguration",
  components: {
  },
  data() {
    return {
      automaticDispatchM4: true,
    };
  },
  created() {
    this.getAutomaticDispatchM4Config();
  },
  mounted() {

  },
  methods: {
    /**
     * 获取自动派单M4配置
     */
    getAutomaticDispatchM4Config() {
      showLoading();

      getAutomaticDispatchM4()
        .then(resp => {
          console.log('自动派单M4配置', resp);

          if (resp.data.status === '100') {
            this.automaticDispatchM4 = resp.data.results;
          } else {
            this.$message.warning(resp.data.message);
          }
        })
        .finally(() => {
          hideLoading()
        })
    },

    /**
     * 更新自动派单M4配置
     */
    handleAutomaticDispatchM4Change(value) {
      console.log('自动派单M4', value);

      showLoading();

      updateAutomaticDispatchM4()
        .then(resp => {
          console.log('更新自动派单M4配置', resp);

          if (resp.data.status === '100') {
            this.$message.success(resp.data.message);
          } else {
            this.$message.warning(resp.data.message);
          }
        })
        .finally(() => {
          hideLoading()

          // 刷新配置
          this.getAutomaticDispatchM4Config();
        })
    }
  }
};
</script>

<style lang="scss" type="text/css">
.page-wrapper {
  .item-wrapper {
    &-top {
      display: flex;
      align-items: center;

      &-title {
        font-size: 18px;
        font-weight: bold;
        margin-right: 16px;
      }
    }

    &-bottom {
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?3ead7c29